import { Route } from '@angular/router';
import { SharedResourcesComponent } from 'app/modules/shared-resources/shared-resources.component';
import { SharedResourcesSharedResourceResolver } from './shared-resources.resolvers';

export const sharedResourcesRoutes: Route[] = [
  {
    path: '',
    component: SharedResourcesComponent,
    children: [
      {
        path: 'projects',
        loadChildren: () =>
          import('app/modules/shared-resources/projects/projects.module').then((m) => m.SharedResourcesProjectsModule),
      },
      {
        path: 'fo',
        loadChildren: () =>
          import('app/modules/shared-resources/folders/folders.module').then((m) => m.SharedResourcesFoldersModule),
      },
      {
        path: 'fi',
        loadChildren: () =>
          import('app/modules/shared-resources/files/files.module').then((m) => m.SharedResourcesFilesModule),
      },
    ],
  },
];
